<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p><a id="ded">
<div class="ctag1">This book is for Mikie.</div>
<div> <br/></div><div class="ctag1">You are the wind beneath my Hadassah arms.</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// adri_9781612430805_oeb_ded_r1.vue?ae327e44